@if (approverInfo?.nextPending) {
    <div class="row align-items-center">
        <div class="col-12">
            <strong>{{ 'Mögliche Freigeber' | translate }}:</strong>
        </div>
        <div class="col">
            @if (approverInfo.nextPending.firstThreeApprovers.length === 0) {
                <div class="row">
                    <div class="col">
                        <span class="text-danger font-09">
                            {{ 'Aktuell sind keine Freigeber vorhanden.' | translate }}
                        </span>
                    </div>
                </div>
            }
            @for (approver of approverInfo.nextPending.firstThreeApprovers; track $index) {
                <div class="row">
                    <div class="col">
                        <span class="next-approver" [attr.data-approver-name]="approver.approver.fullName">
                            {{ approver.approver | person }}
                        </span>
                    </div>
                </div>
            }
            @if (approverInfo.nextPending.possibleApprovers.length > 3) {
                <div class="row">
                    <div class="col">
                        {{
                            'und \{\{count\}\} weitere'
                                | translate: { count: approverInfo.nextPending.possibleApprovers.length - 3 }
                        }}
                    </div>
                </div>
            }
        </div>
        <div class="col-auto">
            <button class="btn btn-outline-dark btn-sm" (click)="openDetails()">
                <em class="fas fa-eye pe-1"></em>
                {{ 'Details' | translate }}
            </button>
        </div>
    </div>
} @else {
    @if (approverInfo?.groups.length > 0) {
        <div class="row">
            <div class="col-auto">
                <button class="btn btn-outline-dark btn-sm" (click)="openDetails()">
                    <em class="fas fa-eye pe-1"></em>
                    {{ 'Freigabedetails' | translate }}
                </button>
            </div>
        </div>
    }
}

@if (isLoadingApproverInfo()) {
    <div class="row align-items-center">
        <div class="col-auto">
            <iim-spinner size="small" color="primary"></iim-spinner>
        </div>
        <div class="col">
            {{ 'Lade Freigeberinformationen...' | translate }}
        </div>
    </div>
}
